export enum ProviderType {
    Breeder = "breeder",
    ShelterRescue = "shelter_rescue",
}

export const getProviderType = (
    orgType: string | null | undefined,
): ProviderType =>
    orgType === "breeder" ? ProviderType.Breeder : ProviderType.ShelterRescue;

export const getListingProviderType = (
    listingProviderType: string | null | undefined,
    orgType: string | null | undefined,
): ProviderType => getProviderType(listingProviderType || orgType);

enum OrganizationType {
    Shelter = "Animal Shelter",
    Rescue = "Animal Rescue",
}

export const getOrganizationType = (
    orgType: string | null | undefined,
): OrganizationType =>
    orgType === "rescue" ? OrganizationType.Rescue : OrganizationType.Shelter;
